/** True when the primary input is not a hover-capable fine pointer — touch
 * phones and tablets. The exact complement of the Tailwind hover query. */
export function isTouchPrimaryViewport(): boolean {
  if (typeof window.matchMedia !== 'function') return false;
  return !window.matchMedia('(hover: hover) and (pointer: fine)').matches;
}
